<div class="metric-target-and-timeleft">
  <div class="metric-bar-target">
    {{ metric | metric : "targets" : { additionalInfo: "goal-view" } }}
    <div class="timeleft" *ngIf="metric.percentTime">{{ metric | metric : "dueDates" }}</div>
  </div>
</div>
